import { render, staticRenderFns } from "./Plano.vue?vue&type=template&id=f1ed8884&scoped=true"
import script from "./Plano.vue?vue&type=script&lang=js"
export * from "./Plano.vue?vue&type=script&lang=js"
import style0 from "./Plano.vue?vue&type=style&index=0&id=f1ed8884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ed8884",
  null
  
)

export default component.exports